import queryString from 'query-string';

import {
  API_ENDPOINT,
  useClientApiV1ReviewsIdContentQuery,
} from '../../../../../../resources/@types/uccSchema';
import { REQUEST_ORIGINAL_CONTENT_KEY } from '../../../../../utils/i18n/constants';

type Params = {
  reviewId: string;
  options?: Parameters<typeof useClientApiV1ReviewsIdContentQuery>[0]['options'];
};

export default function useCourseReviewIdOriginalLangContentQuery({ reviewId, options }: Params) {
  return useClientApiV1ReviewsIdContentQuery({
    url: queryString.stringifyUrl({
      url: API_ENDPOINT.CLIENT_V1_REVIEWS_ID_CONTENT(reviewId),
      query: {
        lang: REQUEST_ORIGINAL_CONTENT_KEY,
      },
    }),
    queryKey: getCourseReviewIdOriginalLangContentQueryKey(reviewId),
    options,
  });
}

export function getCourseReviewIdOriginalLangContentQueryKey(reviewId: string) {
  return [API_ENDPOINT.CLIENT_V1_REVIEWS_ID_CONTENT(reviewId), REQUEST_ORIGINAL_CONTENT_KEY];
}
